import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import ModalLayout from '../../../../ModalLayout';
import ModalFooter from '../../../../ModalFooter';
import s from './HorizontalLayout.scss';
const HorizontalLayout = (_param)=>{
    var { title, message, image, className, footerLeft, footerRight } = _param, rest = _object_without_properties(_param, [
        "title",
        "message",
        "image",
        "className",
        "footerLeft",
        "footerRight"
    ]);
    return /*#__PURE__*/ React.createElement(ModalLayout, _object_spread({
        className: c(s['root'], className),
        footer: /*#__PURE__*/ React.createElement(ModalFooter, {
            left: footerLeft,
            right: footerRight
        }),
        content: /*#__PURE__*/ React.createElement("div", {
            className: s['content-root']
        }, image && /*#__PURE__*/ React.createElement("div", {
            className: s['image']
        }, image), /*#__PURE__*/ React.createElement("div", {
            className: s['title']
        }, title), /*#__PURE__*/ React.createElement("div", {
            className: s['message']
        }, message))
    }, rest));
};
HorizontalLayout.displayName = 'HorizontalLayout';
export default HorizontalLayout;
